import React from 'react';
import { Icon } from 'widgets';

import styles from './PackagesPage.module.scss';

const PackagesPage = () => (
  <div className={styles.container}>
    <div className={styles.welcomeCard}>
      <div className={styles.iconWrapper}>
        <Icon name="inventory" className={styles.icon} />
      </div>
      <h1 className={styles.title}>Welcome to the Packages Section</h1>
      <div className={styles.message}>
        Package management is not available in this dashboard yet.
      </div>
    </div>
  </div>
);

export default PackagesPage;
